import api from "@/lib/api";

export async function downloadDoc(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const blobUrl = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
}

export async function printDoc(url) {
  const preview = window.open("", "_blank");
  if (!preview) throw new Error("popup_blocked");
  try {
    const res = await api.get(url, { responseType: "blob" });
    const blobUrl = window.URL.createObjectURL(res.data);
    preview.location.href = blobUrl;
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 120000);
  } catch (error) {
    preview.close();
    throw error;
  }
}
